export default {"src":"/_next/static/media/logo_full_green.6a741b76.svg","height":3786,"width":17166};